import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './NavigationMenu.css';
import { useUserContext } from '../../contexts/UserContext';
import { Function } from '../../backend/generated-rest-client';

export const NavigationMenu: React.FC = () => {

    const navigate = useNavigate();
    const userContext = useUserContext();
    const [functionList, setFunctionList] = useState<Function[]>(new Array<Function>);

    useEffect(() => {
        userContext.availableFunction(userContext.idToken, {
            onFuncSuccess: function (funcList) {
                console.log('NavigationMenu: SUCCESS funcList.length = ' + funcList.length);
                setFunctionList(funcList);
            },
            onFuncFailure: function (err) {
                console.log('NavigationMenu: FAILURE');
                userContext.logout();
                window.location.href = '/';
            }
        });
    }, []);
      
    const handleMenuChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let index = e.target.selectedIndex;
        let value = e.target.selectedOptions[0].value;
        console.log('handleMenuChange: index=' + index + ', value=' + value);
        if (value != "") {
            navigate(value);
        }
    };
    
    console.log('NavigationMenu: return funcList.length = ' + functionList.length);
    if (functionList?.length < 2) {
        return (
            <div>
            </div>
        );
    };

    return (
        <div>
            <select className="NavigationMenu_menu" onChange={(e) => handleMenuChange(e)}>
                {functionList.map((functionInfo) => {
                    let functionId: string = "/" + functionInfo.functionId;
                    return (
                        <option value={functionId}>{functionInfo.functionName}</option>
                    )
                })}
            </select>
        </div>
    );
}
